// Created by administrator on 2017/8/11

export default [
    {
        path: '/',
        name: '用户管理Frist',
        component: resolve => require(['@/components/views/system/file/user/list'], resolve)
    },
    {
        path: '/home/system/file/user/list',
        name: '用户管理',
        component: resolve => require(['@/components/views/system/file/user/list'], resolve)

    },

    // 编辑客户页
    {
        path: 'file/user/edit',
        name: '编辑用户',
        component: () => import('@/components/views/system/file/user/edit'),
        meta: {
            isEdit: true
        }
    },
    // 新增客户页
    {
        path: 'file/user/add',
        name: '新增用户',
        component: () => import('@/components/views/system/file/user/edit')
    },
    //角色管理页
    {
        path: 'file/user/management',
        name: '管理角色',
        component: () => import('@/components/views/system/file/user/management')
    },
    // 组织管理页
    {
        path: '/home/system/file/organization/list',
        name: '组织管理',
        component: () => import('@/components/views/system/file/organization/list')
    }, {
        path: 'resource/ordinary/list',
        name: '普通资源管理',
        component: () => import('@/components/views/system/resource/ordinary/list'),
        meta: {
            keepAlive: true
        }
    },
    //编辑普通资源页
    {
        path: 'resource/ordinary/edit',
        name: '编辑普通资源',
        component: () => import('@/components/views/system/resource/ordinary/edit'),
        meta: {
            isEdit: true
        }
    },
    //新增普通资源页
    {
        path: 'resource/ordinary/add',
        name: '新增普通资源',
        component: () => import('@/components/views/system/resource/ordinary/edit'),
        meta: {
            isEdit: false
        }
    },
    {
        path: 'resource/tree/list',
        name: '树形资源管理',
        component: () => import('@/components/views/system/resource/tree/list')
    },

    {
        path: 'authority/roles/list',
        name: '角色管理',
        component: () => import('@/components/views/system/authority/roles/list'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: 'authority/roles/edit',
        name: '编辑角色',
        component: () => import('@/components/views/system/authority/roles/edit'),
        meta: {
            isEdit: true,
        }
    },
    {
        path: 'authority/roles/add',
        name: '添加角色',
        component: () => import('@/components/views/system/authority/roles/edit'),
    },
    {
        path: 'authority/roles/resource',
        name: '角色资源权限',
        component: () => import('@/components/views/system/authority/roles/resource'),
    },
    {
        path: 'taxationOffice/list',
        name: '主管税务所',
        component: () => import('@/components/views/system/taxationOffice/list.vue'),
    },
    {
        path: 'landGradeManager/list',
        name: '土地等级配置',
        component: () => import('@/components/views/system/landGradeManager/list.vue'),
    },
    {
        path: 'landTaxInputGuide/landTaxInputGuide',
        name: '土地基本信息填报配置',
        component: () => import('@/components/views/system/landTaxInputGuide/landTaxInputGuide.vue'),
    }
    ,
    {
        path: 'houseTaxInputGuide/houseTaxInputGuide',
        name: '房产基本信息填报配置',
        component: () => import('@/components/views/system/houseTaxInputGuide/houseTaxInputGuide.vue'),
    }
    ,
    {
        path: 'taxTimeSetting/list',
        name: 'taxTimeSetting',
        component: () => import('@/components/views/system/taxTimeSetting/list.vue'),
    }
    ,
    {
        path: 'materialGuide/list',
        name: 'materialGuidelist',
        component: () => import('@/components/views/system/materialMessageGuide/list.vue'),
    }


]




// WEBPACK FOOTER //
// ./src/router/system.js